var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(!_vm.loading && _vm.isAuth)?_c('v-main',{staticClass:"main-background"},[(_vm.$route.path !== '/login')?_c('navbar'):_vm._e(),_c('global-snack-bar',{staticClass:"snackbar-text"}),_c('router-view')],1):_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }